var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Link as InternalLink } from 'react-router-dom';
/**
 * Base component for links
 * TODO: Add forceExternal and forceSameWindow to core LinkBase implementation
 */
export const LinkBase = (props) => {
    const { forceExternal, forceSameWindow, to, children } = props, otherProps = __rest(props, ["forceExternal", "forceSameWindow", "to", "children"]);
    const external = forceExternal === true || to.match(/\w+:\/\/.*/);
    if (external) {
        return (_jsx("a", Object.assign({ href: to }, otherProps, { target: forceSameWindow ? undefined : '_blank', rel: "noreferrer noopener" }, { children: children }), void 0));
    }
    return (_jsx(InternalLink, Object.assign({ to: to }, otherProps, { children: children }), void 0));
};
//# sourceMappingURL=LinkBase.js.map